import { render, staticRenderFns } from "./list-value-delete-form.vue?vue&type=template&id=ae1d12a2&"
import script from "./list-value-delete-form.vue?vue&type=script&lang=js&"
export * from "./list-value-delete-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports